<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Animation Call
new WOW().init();
// Testimonial Slider
jQuery(document).ready(function($) {
      $('.testimonial_inner_section').slick({
        dots: false,
        infinite: true,
        centerMode: true,
        centerPadding: '0',
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [{
          breakpoint: 1024,
          settings: {
              dots: true,
              arrows: false,
          }
        },{
          breakpoint: 768,
          settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: true,
          }
        },
        {
           breakpoint: 575,
           settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
           }
        }]
    });
});
// Product Tab
  $('.tab-menu li a').on('click', function(){
		   	var target = $(this).attr('data-rel');
			$('.tab-menu li a').removeClass('active');
		   	$(this).addClass('active');
		   	$("#"+target).fadeIn('slow').siblings(".tab-box").hide();
		   	return false;
  });
// Product Review Section
jQuery('div#judgeme_product_reviews').addClass('container');
// Welcome to section Animation
jQuery('.column_change .about_us_inner_sec .col-sm-6:first-child').removeClass('fadeInLeft');
jQuery('.column_change .about_us_inner_sec .col-sm-6:last-child').removeClass('fadeInRight');
jQuery('.column_change .about_us_inner_sec .col-sm-6:first-child').addClass('fadeInRight');
jQuery('.column_change .about_us_inner_sec .col-sm-6:last-child').addClass('fadeInLeft');
jQuery('.about_veritcle_sec .about_us_inner_sec .col-sm-6:first-child').removeClass('fadeInLeft');
jQuery('.about_veritcle_sec .about_us_inner_sec .col-sm-6:last-child').removeClass('fadeInRight');
jQuery('.about_veritcle_sec .about_us_inner_sec .col-sm-6:first-child').addClass('fadeInUp');
jQuery('.about_veritcle_sec .about_us_inner_sec .col-sm-6:last-child').addClass('fadeInUp');
jQuery('.section_class.our_stor_main_sec .about_us_inner_sec .col-sm-6:first-child').removeClass('fadeInLeft ');
jQuery('.section_class.our_stor_main_sec .about_us_inner_sec .col-sm-6:last-child').removeClass('fadeInRight');
jQuery('.section_class.our_stor_main_sec .about_us_inner_sec .col-sm-6:first-child').addClass('fadeInUp ');
jQuery('.jdgm-rev-widg__summary-text').text('Leave a review and help us spread the joy of Froodelite');

// Modify the collections page URL
let currentUrl = window.location.href;
if ( currentUrl.includes("/collections/gifting") && !currentUrl.includes("sort_by=")) {
    let newUrl = currentUrl.includes("?")
        ? currentUrl + "&sort_by=manual"
        : currentUrl + "?sort_by=manual";

    window.location.href = newUrl;
} else if ( currentUrl.includes("/collections/") && !currentUrl.includes("sort_by=")) {
    let newUrl = currentUrl.includes("?")
        ? currentUrl + "&sort_by=best-selling"
        : currentUrl + "?sort_by=best-selling";

    window.location.href = newUrl;
}
